import { DEFAULT_LANG, OTHER_LANGUAGES } from "../../constants";

export const getLangForPagePath = (pagePath) =>
  OTHER_LANGUAGES.find((lang) => pagePath.startsWith(`/${lang}/`)) ||
  DEFAULT_LANG;
